export default __webpack_public_path__ + "static/media/paso11-icon.17bf28fc.svg";